import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

export default function redirection(props: ReferenciaContenido) {
    window.open(props.redireccionBoton, "_self");
    return (<></>)
}
